import { REMOVE_REVIEWED_FORM_IDS } from "../../redux/actions/action.types";

export default function removeReviewedFormIds(stateSetter: any, reviewedIdsToRemove: any) {
  stateSetter({
    type: REMOVE_REVIEWED_FORM_IDS,
    payload: reviewedIdsToRemove,
  });
}
